<style lang="scss">
  header {
    width: 100%;
    display: flex;
    background: #fff;
    justify-content: space-between;
    padding: 1rem;

    > div {
      padding: 0.5rem;
      display: flex;
      flex-direction: column;
      justify-content: center;

      > h1 {
        color: #425466;
        font-size: 1.75rem;
        line-height: 120%;

        > span {
          color: #007dd9;
        }
      }
      > p {
        color: #8c8c8c;
        font-size: 1rem;
        font-weight: 400;
        line-height: 160%;
        letter-spacing: 0.32px;
      }
    }
    #badgesDiv {
      width: 25rem;
    }
  }
</style>

<script>
  import BadgesWidget from "./Components/BadgesWidget.svelte";
  import SkeletonLoader from "./Components/SkeletonLoader.svelte";
  import { firstNameStore } from "./stores";
  import { trainingHubTaskStore } from "../../../api-stores/training-hub-store";

  const { meta } = trainingHubTaskStore;
</script>

<header>
  {#if !$meta.firstFetchDone}
    <SkeletonLoader type="main-header" />
  {:else}
    <div>
      <h1>
        <span>Hello {$firstNameStore}!</span> Welcome to the SourceWhale Training
        Hub.
      </h1>
      <p>
        Access everything you need to succeed with SourceWhale, from training to
        support.
      </p>
    </div>
    <div id="badgesDiv">
      <BadgesWidget />
    </div>
  {/if}
</header>
